<template>
  <div class="is-flex is-flex-direction-column" style="height: 100%">
    <header class="is-flex is-justify-content-space-between p-4 is-align-items-center has-background-kymetalightblue has-text-white">
      <h4>
        <b-tooltip label="Refreshing..." v-if="isRefreshing">
          <font-awesome-icon :icon="['far', 'spinner-third']" spin />
        </b-tooltip>
        <font-awesome-icon @click.ctrl="getTerminal" :icon="['far', 'satellite-dish']" v-else />
        <span class="ml-4">{{terminal?.name}}</span>
      </h4>
      <div class="block">
        <font-awesome-icon class="is-clickable" :icon="['far', 'times-circle']" size="lg" @click="close" title="Close" />
      </div>
    </header>
    <nav class="p-4 has-background-white-bis">
      <div class="tabs">
        <ul>
          <router-link 
          tag="li" 
          :to="{ name: 'terminalOverview' }" 
          ref="terminalOverview" 
          active-class="is-active">
            <a>
              <span class="icon"><font-awesome-icon :icon="['far', 'file-chart-line']" /></span>
              <span>Overview</span>
            </a>
          </router-link>
          <router-link 
          tag="li" 
          :to="{ name: 'terminalConfiguration' }" 
          ref="terminalConfiguration" 
          active-class="is-active">
            <a>
              <span class="icon"><font-awesome-icon :icon="['far', 'cog']" /></span>
              <span>Service Configuration</span>
            </a>
          </router-link>
          <router-link 
          tag="li" 
          :to="{ name: 'terminalUsage' }" 
          ref="terminalUsage" 
          active-class="is-active">
            <a>
              <span class="icon"><font-awesome-icon :icon="['far', 'exchange-alt']" /></span>
              <span>Usage History</span>
            </a>
          </router-link>
          <router-link 
          tag="li" 
          :to="{ name: 'terminalMetrics' }" 
          ref="terminalMetrics" 
          active-class="is-active">
            <a>
              <span class="icon"><font-awesome-icon :icon="['far', 'chart-area']" /></span>
              <span>Metrics</span>
            </a>
          </router-link>
          <router-link 
          tag="li" 
          :to="{ name: 'terminalJson' }" 
          ref="terminalJson" 
          active-class="is-active"
          v-if="$hasRole('Super User,Kymeta Admin')">
            <a>
              <span class="icon"><font-awesome-icon :icon="['far', 'code']" /></span>
              <span>JSON</span>
            </a>
          </router-link>
        </ul>
      </div>
    </nav>
    <div class="kpt-detail-content has-background-white-bis">
      <router-view></router-view>
    </div>
  </div>
</template>
<script setup>
import { onMounted, computed } from 'vue';
import { useRoute, useRouter, onBeforeRouteUpdate } from 'vue-router/composables';
import { useTerminalsStore } from './terminals-store';
import { useUserStore } from '../user/user-store';

const store = useTerminalsStore();
const userStore = useUserStore();
const route = useRoute();
const terminal = computed(() => store.state.terminal);
const getTerminal = async () => {
  await store.dispatch('fetchTerminal', { id: route.params.id });
}
const getHubState = async () => {
  await store.dispatch('fetchTerminalHubState');
}

onBeforeRouteUpdate(async (to, from, next) => {
  if (to.params.id != from.params.id && !!(to.params.id)) {   
    await store.dispatch('fetchTerminal', { id: to.params.id });
    if (terminal?.value?.activeSubscription?.active) { // only fetch hub state if there's an active subscription
      await getHubState(); 
    }
    await store.dispatch('fetchTerminalHubState');
  }
  next();
});

const router = useRouter();

const close = () => {
  store.commit('fetchTerminal', null);
  router.push({ path: '/terminals' });
}
const isRefreshing = computed(() => store.state.terminalLoading);

onMounted(async () => {
  await getTerminal();
  await userStore.dispatch('setRecentTerminal', terminal.value);
  if (terminal?.value?.activeSubscription) { // only fetch hub state if there's an active subscription
    await getHubState(); 
  }
});
</script>
